<template>
  <div class="contract">
    <div class="contract-search">
      <div class="title">
        <h1>合同</h1>
        <a-button type="primary" @click="newContract" class="el_button el-button--primary" v-hasPermi="['system:contractsInfo:add']">
          新增合同
        </a-button>
      </div>
      <!-- <div class="lease-box"><span>出租合同</span> -->
      <!-- <span>出售合同</span> -->
      <!-- </div> -->
      <div class="search-box">
        <a-form-model layout="inline" :model="form" lable="150" labelAlign="right" :labelCol="{ style: 'width: 80px' }">
          <div class="intelligence-searh">
            <a-form-model-item>
              <a-input placeholder="智能搜索" @keyup.native.13="getContractList" v-model="form.search">
                <a-icon slot="prefix" type="search" />
              </a-input>
            </a-form-model-item>
          </div>
          <div class="inline-box">
            <a-form-model-item label="合同类型">
              <a-select v-model="form.contractType" placeholder="请选择合同类型">
                <a-select-option v-for="(item, index) in contractTypeOpts" :key="index" :value="item.value">{{ item.label }}</a-select-option>
              </a-select>
            </a-form-model-item>

            <a-form-model-item label="签约时间">
              <a-date-picker placeholder="开始日期" style="width: 158px" v-model="form.startTime" />
              -
              <a-date-picker placeholder="结束日期" style="width: 158px" v-model="form.endTime" />
            </a-form-model-item>
            <a-form-model-item>
              <a-radio-group class="week-month-season-year" default-value="本月" v-model="currentDate" @change="handleChange" button-style="solid">
                <a-radio-button value="本周">本周</a-radio-button>
                <a-radio-button value="本月">本月</a-radio-button>
                <!-- <a-radio-button value="本季"> 本季 </a-radio-button> -->
                <a-radio-button value="本年">本年</a-radio-button>
              </a-radio-group>
            </a-form-model-item>
          </div>
          <a-row>
            <a-form-model-item label="业绩分配">
              <a-select v-model="form.isAllot" placeholder="请选择业绩分配">
                <a-select-option value="">全部</a-select-option>
                <a-select-option value="Y">已分配</a-select-option>
                <a-select-option value="N">未分配</a-select-option>
              </a-select>
            </a-form-model-item>
            <a-form-model-item label="组织">
              <a-tree-select
                v-model="mixin_deptId"
                style="width: 150px"
                :dropdown-style="{ maxHeight: '400px', overflow: 'auto' }"
                :tree-data="deptOptions"
                placeholder="部门"
                :replaceFields="replaceFields"
                tree-default-expand-all
                @change="handleChangeTreesignId"
                @select="selectTreeNode"
              ></a-tree-select>
              <a-select v-model="form.signId" @dropdownVisibleChange="handleOption($event)" placeholder="人员" style="width: 110px">
                <a-select-option v-for="item in userList" :key="item.userId" :value="item.userId">
                  {{ item.nickName }}
                </a-select-option>
              </a-select>
            </a-form-model-item>
            <a-form-model-item label="状态" class="btn-control">
              <a-select v-model="form.auditStatus" placeholder="请选择状态">
                <a-select-option v-for="(item, index) in isOptions" :key="index" :value="item.dictValue">{{ item.dictLabel }}</a-select-option>
              </a-select>
            </a-form-model-item>
            <a-form-model-item class="btn-control">
              <a-button class="el_button el_button_b submit-btn" @click="reset" style="margin-right: 10px">重置</a-button>
              <a-button class="el_button el-button--primary submit-btn" type="primary" style="margin-right: 10px" @click="getContractList">
                查询
              </a-button>

              <template>
                <a-button class="el_button el-button--primary submit-btn" type="primary" @click="handleExportData">导出</a-button>
              </template>
            </a-form-model-item>
          </a-row>
        </a-form-model>
      </div>
    </div>
    <div class="contract-list">
      <a-tabs type="card" class="menu" @change="onClickContractList">
        <a-tab-pane key="1" tab="全部" v-if="isShowCard('system:contractsInfo:listCard')"></a-tab-pane>
        <a-tab-pane key="3" tab="待审核" v-if="!isShowCard('system:contractsInfo:listCard')"></a-tab-pane>
        <a-tab-pane key="99" tab="待审核" v-if="isShowCard('system:contractsInfo:listCard')"></a-tab-pane>
        <a-tab-pane key="10" tab="审核中" v-if="isShowCard('under_review')"></a-tab-pane>

        <a-tab-pane key="8" tab="待交件" v-if="isShowCard('system:contractsInfo:listCard')"></a-tab-pane>
        <a-tab-pane key="9" tab="待结佣" v-if="isShowCard('system:contractsInfo:listCard')"></a-tab-pane>
        <a-tab-pane key="7" tab="待归档" v-if="isShowCard('system:contractsInfo:listCard')"></a-tab-pane>
        <a-tab-pane key="4" tab="已归档" v-if="isShowCard('system:contractsInfo:listCard')"></a-tab-pane>
      </a-tabs>
      <div class="list-box">
        <a-spin :spinning="listLoding">
          <contractList :tabKey="this.form.contractResourceType" :contractListData="AllList" />
        </a-spin>
      </div>

      <!-- 统计 -->
      <a-row v-if="['1', '4', '7', '8', '9'].includes(form.contractResourceType) && AllList.length">
        <a-col :span="2" align="center">总应收：{{ formatPrice(statisticData.receivableAmount || 0) }}</a-col>
        <a-col :span="2" align="center">总实收：{{ formatPrice(statisticData.realityAmount || 0) }}</a-col>
        <a-col :span="2" align="center">总未收：{{ formatPrice(statisticData.receivableAmount - statisticData.realityAmount) || 0 }}</a-col>
        <a-col :span="3" align="center">总成交金额：{{ formatPrice(statisticData.rentExpense) || 0 }}</a-col>
        <a-col :span="2" align="center">总面积：{{ formatPrice(statisticData.grossFloorArea) || 0 }}㎡</a-col>
        <a-col v-if="form.contractResourceType == '1'" :span="3" align="center">
          总结单业绩：{{ formatPrice(statisticData.restCountFee * 1 - statisticData.amountOfRedPunch * 1) || 0 }}
        </a-col>
      </a-row>

      <!-- 分页 -->
      <!--         show-quick-jumper -->
      <a-pagination
        style="margin-right: 30px"
        class="ant-table-pagination"
        show-size-changer
        :current="queryParam.pageNum"
        :total="total"
        :showTotal="(total) => `共 ${total} 条`"
        :page-size="queryParam.pageSize"
        :pageSizeOptions="['5', '10', '20', '30', '40', '100']"
        @showSizeChange="onShowSizeChange"
        @change="changeSize"
      />
    </div>
  </div>
</template>

<script>
import { contractsInfoList, contractsStatistics } from '@/api/system/contract';
import moment from 'moment';
import contractList from '@/components/contractList/index.vue';
import touristApi from '@/api/system/tourist/tourist';
import { treeSelectMixin } from '@/mixin/treeSelect';
import { getBeginMonth, getBeginWeek, getCurrentDate, getquarterDay, getYearFirstDay } from '@/utils/date';

export default {
  name: 'ContractList',
  components: {
    contractList
  },
  mixins: [treeSelectMixin],

  data() {
    const userInfo = this.$getters.userInfo;
    // console.log(,'008988')
    const isShowCard = (auth) => {
      return userInfo.data.permissions.includes(auth) || userInfo.data.permissions.includes('*:*:*');
    };
    // userInfo.data.permissions.includes('system:contractsInfo:listCard') || userInfo.data.permissions.includes('*:*:*')
    return {
      isShowCard, // 是否显示选项卡
      contractCode: undefined,
      form: {
        contractResourceType: isShowCard('system:contractsInfo:listCard') ? '1' : '3',
        pageNum: 1,
        pageSize: this.$getters.pageSize,
        signId: undefined,
        isAllot: '',
        contractType: null,
        search: '',
        endTime: this.$moment(getCurrentDate()).format('YYYY-MM-DD'),
        startTime: this.$moment(getBeginMonth()).format('YYYY-MM-DD'),
        auditStatus: '' // 状态
      },
      data: [],
      AllList: [],
      isOptions: [{ dictValue: '', dictLabel: '全部' }],
      contractTypeOpts: [
        { label: '全部', value: null },
        { label: '租', value: '1' },
        { label: '售', value: '2' }
      ], // 合同类型
      deptList: [], // 部门列表
      userList: [], // 人员列表
      isuser: true,
      queryParam: {
        pageNum: 1,
        pageSize: this.$getters.pageSize
      },
      total: 0,
      listLoding: false,
      currentDate: '本月',
      statisticData: {} // 已归档统计的总数居
    };
  },

  methods: {
    formatPrice(val) {
      if ((val + '').indexOf('.') >= 0) {
        if (typeof val === 'string') {
          return Number(val).toFixed(2);
        }
        return val.toFixed(2);
      }
      return val + '.00';
    },
    /** tab 切换
     * 获取合同列表
     * 点击不同状态获取列表
     */
    onClickContractList(e) {
      this.form.contractResourceType = e;
      this.form.pageNum = 1;
      this.form.auditStatus = null;
      this.getContractList();
    },
    /**
     * @params keys item当前节点
     *
     */
    selectTreeNode(keys, item) {
      console.log(keys, item, 'keys,item');
    },
    /**
     * 合同列表查询
     * 默认为全部
     */
    getContractList() {
      this.listLoding = true;
      const { startTime, endTime } = this.form;
      if (startTime) {
        this.form.startTime = moment(startTime).format('YYYY-MM-DD');
      }
      if (endTime) {
        this.form.endTime = moment(endTime).format('YYYY-MM-DD');
      }
      const { pageNum, pageSize } = this.queryParam;
      this.form.pageNum = pageNum;
      this.form.pageSize = pageSize;
      if (this.form.contractResourceType == 99) {
        this.form.contractResourceType = '3';
        // this.form.auditStatus = '1'
      }
      if (this.mixin_deptId) {
        this.form.teamId = this.mixin_deptId;
      }
      this.getStatistics();
      // console.log(this.mixin_deptId,'this.mixin_deptId')
      contractsInfoList(this.form).then((res) => {
        this.listLoding = false;
        if (res.code === 200) {
          console.log(res.data.records, 'res.data.records', '111111');
          this.total = res.data.total;
          this.AllList = [];
          this.AllList = res.data.records;
          this.AllList.forEach((element) => {
            this.isOptions.forEach((item) => {
              if (item.dictValue === element.auditStatus) {
                element.auditStatus = item.dictValue;
              }
            });
          });
          this.AllList = [...this.AllList];
        } else {
          this.$message.warning('房源信息获取失败');
        }
      });
    },
    // 新增合同
    newContract() {
      sessionStorage.setItem('history', JSON.stringify({ fromPage: 'add' }));
      this.$router.push('/contract/new');
    },
    // 部门下拉列表
    getDeptList() {
      touristApi.getDeptList().then((res) => {
        const { code, data } = res;
        if (code === 200) {
          this.deptList = data;
        }
      });
    },
    // 人员列表
    getDepUserList(deptId) {
      if (deptId) {
        this.isuser = false;
        this.form.signId = undefined;
      } else {
        this.isuser = true;
      }
      touristApi.getUserList({ deptId }).then((res) => {
        const { code, rows } = res;
        if (code === 200) {
          this.userList = rows;
        }
      });
    },
    reset() {
      this.contractCode = undefined;
      this.mixin_deptId = undefined;
      this.form = {
        contractResourceType: this.form.contractResourceType,
        pageNum: 1,
        pageSize: this.$getters.pageSize,
        contractType: null,
        signId: undefined,
        search: '',
        endTime: this.$moment(getCurrentDate()).format('YYYY-MM-DD'),
        startTime: this.$moment(getBeginMonth()).format('YYYY-MM-DD'),
        auditStatus: '' // 状态
      };
      this.getDeptList();
      this.getContractList();
      this.isuser = true;
    },
    // 客源分页
    onShowSizeChange(current, pageSize) {
      this.queryParam.pageSize = pageSize;
      this.getContractList();
    },
    changeSize(current, pageSize) {
      this.queryParam.pageNum = current;
      this.queryParam.pageSize = pageSize;
      this.getContractList();
    },
    // 时间变化
    handleChange(e) {
      if (e.target.value === '本周') {
        this.form.startTime = this.$moment(getBeginWeek()).format('YYYY-MM-DD');
      } else if (e.target.value === '本月') {
        this.form.startTime = this.$moment(getBeginMonth()).format('YYYY-MM-DD');
      } else if (e.target.value === '本季') {
        this.form.startTime = this.$moment(getquarterDay()).format('YYYY-MM-DD');
      } else {
        this.form.startTime = this.$moment(getYearFirstDay()).format('YYYY-MM-DD');
      }
      this.getContractList();
      this.current = e.target.value;
    },
    // 获取统计
    getStatistics() {
      if (!['1', '4', '7', '8', '9'].includes(this.form.contractResourceType)) {
        return;
      }
      const params = { ...this.form };
      if (params.pageNum) {
        delete params.pageNum;
      }
      if (params.pageSize) {
        delete params.pageSize;
      }
      contractsStatistics(params).then((res) => {
        if (res.code === 200) {
          this.statisticData = res.data;
        }
      });
    },
    /** 导出 */
    handleExportData() {
      const { startTime, endTime } = this.form;
      if (startTime) {
        this.form.startTime = moment(startTime).format('YYYY-MM-DD');
      }
      if (endTime) {
        this.form.endTime = moment(endTime).format('YYYY-MM-DD');
      }
      this.downloadPost('/contractsInfo/export', { ...this.form }, `p_${new Date().getTime()}.xls`);
    }
  },
  created() {
    this.getDeptList();
    // 字典列表
    this.getDicts('audit_status').then((response) => {
      this.isOptions = this.isOptions.concat(response.data).filter((el) => el.dictValue != '5' && el.dictValue != '2');
    });
    this.getContractList();
    this.getStatistics();
  }
};
</script>
<style lang="less" scoped>
.contract {
  height: 100%;
  display: flex;
  flex-direction: column;
  .contract-search {
    padding: 20px;
    background: #fff;
    .title {
      display: flex;
      justify-content: space-between;
      color: #222222;
      h1 {
        font-size: 20px;
        font-weight: 700;
      }
      button {
        width: 100px;
        height: 40px;
      }
    }
    .lease-box {
      color: #666666;
      span {
        font-weight: 700;
        font-size: 16px;
        color: var(--ThemeColor);
        // color: #000;
      }
      span:last-child {
        display: inline-block;
        // margin-left: 30px;
      }
    }
    .search-box {
      /deep/.ant-select-selection {
        width: 160px;
      }
      /deep/.ant-form-item-children {
        display: flex;
      }
      .intelligence-searh {
        margin: 30px 0;
        /deep/.ant-input-affix-wrapper .ant-input {
          width: 300px;
          border-radius: 30px;
        }
      }
      .inline-box {
        margin: 0 0 20px 0px;
      }
      /deep/.ant-form-item-control {
        margin-right: 40px;
      }
    }
  }
  .contract-list {
    flex: 1;
    margin-top: 10px;
    background-color: #fff;

    /deep/.ant-tabs-tab-active {
      // background-color: var(--ThemeColor);
      background-color: var(--ThemeColor);
      color: #fff !important;
      border-radius: 5px;
    }
    // /deep/.ant-tabs .ant-tabs-top-content {
    // padding: 20px;
    // }
  }
}
.menu {
  padding-top: 20px;
  .serachmenu {
    margin-top: 10px;
    /deep/.ant-select-selection {
      width: 75px;
    }
  }
  /deep/.ant-tabs-nav-scroll {
    height: 37px;
  }
  /deep/.ant-tabs-nav-container {
    margin-left: -20px;
    margin-bottom: -3px;
  }

  /deep/ .ant-tabs-bar {
    border-bottom: 3px solid var(--ThemeColor);
    padding-left: 20px;
    width: 98%;
    margin: 0 auto;
  }

  /deep/.ant-tabs-tab {
    margin-right: 0px;
    border: none;
    background-color: #ffffff;
  }
  /deep/ .ant-tabs-tab-active {
    background-color: var(--ThemeColor);
    color: #fff;
    border-radius: 5px;
  }
}
.submit-btn {
  width: 60px !important;
}
/deep/ .ant-form-item-control {
  margin-right: 10px !important;
}
.list-box {
  padding: 0 20px;
}
</style>
